module.exports = __webpack_public_path__ + "static/img/quan03.724029f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/quan03.png
// module id = 6RB8
// module chunks = 0